<template>
  <div class="detail-container">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>销售产品明细统计</span>
      </div>
      <el-button size="small" icon="el-icon-back" @click="goBack">返回销售成本统计</el-button>
    </div>

    <div class="search-area">
      <el-input
        v-model="searchParams.productName"
        placeholder="产品名称"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
      ></el-input>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="合同开始日期"
        end-placeholder="合同结束日期"
        value-format="yyyy-MM-dd"
        class="search-input date-picker"
      ></el-date-picker>
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="productName" label="产品名称" min-width="140" align="center"></el-table-column>
        <el-table-column prop="specModel" label="规格型号" min-width="120" align="center"></el-table-column>
        <el-table-column prop="materialRequirement" label="材质要求" min-width="120" align="center"></el-table-column>
        <el-table-column prop="salesQuantity" label="销售数量" width="100" align="center"></el-table-column>
        <el-table-column prop="shippedQuantity" label="发货数量" width="100" align="center"></el-table-column>
        <el-table-column prop="productCost" label="产品成本(元)" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.productCost) }}
          </template>
        </el-table-column>
        <el-table-column prop="salesAmount" label="销售金额(元)" width="120" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.salesAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="settled" label="是否结算" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.settled ? 'success' : 'info'" size="small">
              {{ scope.row.settled ? '已结算' : '未结算' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="settlementQuantity" label="结算数量" width="100" align="center"></el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'SalesProductDetail',
  data() {
    return {
      dateRange: [],
      searchParams: {
        productName: ''
      },
      loading: false,
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/data/sales-statistics' })
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.dateRange = []
      this.searchParams.productName = ''
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize
      }
      if (this.searchParams.productName && this.searchParams.productName.trim()) {
        params.productName = this.searchParams.productName.trim()
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.contractStartDate = this.dateRange[0]
        params.contractEndDate = this.dateRange[1]
      }
      api.statistics.getSalesProductDetails(params)
        .then(response => {
          if (response.data && response.data.success) {
            const data = response.data.data || {}
            this.tableData = data.content || []
            this.pagination.total = data.totalElements || 0
          } else {
            this.tableData = []
            this.$message.error(response.data?.message || '获取销售产品明细失败')
          }
        })
        .catch(err => {
          this.tableData = []
          this.$message.error(err.response?.data?.message || '获取销售产品明细失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  padding: 20px;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.title-mark {
  width: 4px;
  height: 18px;
  background: #409EFF;
  margin-right: 10px;
}
.search-area {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.search-input {
  width: 200px;
}
.date-picker {
  width: 300px;
}
.table-area {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
</style>
